import { icons, IconProps } from '@tabler/icons-react';
import React from 'react';

type TablerIcon = keyof typeof icons;

type TablerIconDynamicProps = IconProps & {
  icon: string;
};

const TablerIconDynamic: React.FC<TablerIconDynamicProps> = ({ icon, ...props }) => {
  const Icon = icons[icon as TablerIcon];

  if (Icon) {
    return <Icon {...props} />;
  }

  // mui compatibility
  return <i className="material-icons">{icon}</i>;
};

export default TablerIconDynamic;
